/* ============================================================
   CLARTÉ PARIS — site-wide experience layer
   - Film grain overlay (all pages)
   - Gold cursor light (desktop / fine pointers, all pages)
   - Cinematic intro reveal (homepage only, once per session)
   Pure progressive enhancement. Respects prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(cls) {
    var d = document.createElement('div');
    d.className = cls;
    d.setAttribute('aria-hidden', 'true');
    return d;
  }

  function init() {
    var body = document.body;
    if (!body || body.getAttribute('data-clarte-ready')) return;
    body.setAttribute('data-clarte-ready', '1');

    /* ---- Film grain (CSS-animated, all pages) ---- */
    body.appendChild(el('clarte-grain'));

    /* ---- Gold cursor light (fine pointers only) ---- */
    if (!reduce && window.matchMedia('(pointer:fine)').matches) {
      var cur = el('clarte-cursor');
      body.appendChild(cur);
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2, tx = cx, ty = cy;
      window.addEventListener('mousemove', function (e) {
        tx = e.clientX; ty = e.clientY;
        body.classList.add('clarte-cursor-on');
      });
      (function loop() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
        requestAnimationFrame(loop);
      })();
    }

    /* ---- Cinematic intro (homepage only, once per session) ---- */
    var main = document.getElementById('MainContent');
    var tpl = main ? (main.getAttribute('data-template') || '') : '';
    var isHome = tpl.indexOf('index') === 0;
    if (!isHome) return;

    var seen = false;
    try { seen = !!sessionStorage.getItem('clarte_seen'); } catch (e) {}
    if (reduce || seen) return;
    try { sessionStorage.setItem('clarte_seen', '1'); } catch (e) {}

    var intro = document.createElement('div');
    intro.className = 'clarte-intro';
    intro.setAttribute('aria-hidden', 'true');
    intro.innerHTML =
      '<div class="clarte-intro__inner">' +
        '<span class="clarte-intro__eyebrow">Maison de Joaillerie — Paris</span>' +
        '<span class="clarte-intro__word"><b>C</b><b>L</b><b>A</b><b>R</b><b>T</b><b>É</b></span>' +
        '<span class="clarte-intro__rule"></span>' +
      '</div>';
    body.appendChild(intro);

    var de = document.documentElement;
    de.style.overflow = 'hidden';
    setTimeout(function () { intro.classList.add('is-leaving'); }, 2200);
    setTimeout(function () {
      intro.classList.add('is-done');
      de.style.overflow = '';
      if (intro.parentNode) intro.parentNode.removeChild(intro);
    }, 3250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
